<template>
    <b-modal id="down-payment-form-modal" title="BootstrapVue" centered class="d-print-none" size="sm">
        <template #modal-header="{ close }" class="border-0">
          <h5 class="text-center w-100 fw-bold" style="font-size: 16px;">
            Pilih Template DP
          </h5>
        </template>
        <template #modal-footer="{ ok, hide }">
          <b-button variant="outline-dark" @click="ok()" class="text-dark-blue" block>
            Batal
          </b-button>
        </template>
        <div class="d-flex flex-column gap-3">
            <a href='/documents/Template Nota Panen (BRS).pdf' download>
                <div :class="`border border-2 item p-3 rounded-3 d-flex w-100 justify-content-between align-items-center`" role="button">
                    <div :class="`text-primary`" style="font-size: 14px;">
                        BRS
                    </div>
                </div>
            </a>
            <a href='/documents/Template Nota Panen (LCS).pdf' download>
                <div :class="`border border-2 item p-3 rounded-3 d-flex w-100 justify-content-between align-items-center`" role="button">
                    <div :class="`text-primary`" style="font-size: 14px;">
                        LCS
                    </div>
                </div>
            </a>
        </div>
    </b-modal>
</template>

<script>
export default {
  name: "down-payment-form-export",
  props: {
    items: {
      type: Array,
      default: () => [
      ]
    }
  },
  data() {
    return {
      tableItems: this.lodash.cloneDeep(this.exportableItems),
      loading: false,
      isValid: true,
      errors: {},
      selected: [],
      selectedAll: null,
      exportableItems: this.items.slice(0),
      isAllSelected: false,
    }
  },
  watch: {
    'exportableItems': {
      handler: function () {
        this.isAllSelected = this.exportableItems.every(item => item.$checked);
        this.$emit('update:checked', this.exportableItems);
      },
      deep: true,
    },
    'items': {
      handler: function () {
        this.exportableItems = this.items.slice(0);
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
  },
  methods: {
    selectAll(){
      if(this.isAllSelected) {
        this.exportableItems.forEach(item => {
          this.$set(item, '$checked', false);
        });
        return;
      }
      this.exportableItems.forEach(item => {
        this.$set(item, '$checked', true);
      });
    },
    handlePrint(){
      window.print();
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep{
  .custom-checkbox .custom-control-label::before {
    border-radius: 0.25rem;
  }
  .modal-header, .modal-footer {
    border: none !important;
  }
  
  @media print {
    .modal, .modal-backdrop {
      display: none !important;
    }
  }

  .item {
    background: #F5FAFF;
    border-color: #D9E9F5 !important;
    transition: all 0.2s ease-in;
    > div {
        font-weight: 400;
        font-size: 14px;
    }

    &:hover {
        background: #0084F3;
        > div {
            color: white !important;
        }
    }

  }
}
</style>
